// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D3-z","displaySixCardTiles":"E3-z"};